import { render } from "./AdminFaqQuestion.vue?vue&type=template&id=4ad855ff"
import script from "./AdminFaqQuestion.vue?vue&type=script&lang=js"
export * from "./AdminFaqQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__